import { NgModule } from '@angular/core';
import {errorMessages} from "../../core/error/errorMessages";



@NgModule()
export class TeletransmissionModule {
    constructor() {
        errorMessages.set('MEDICAL_TELETRANSMISSION_PRODUCT_CODE_CHANGE_NOT_ALLOWED', 'Vous ne pouvez pas changer le code de sécurité sociale.')
        errorMessages.set('MEDICAL_TELETRANSMISSION_INVALID_CREDENTIALS', 'Le nom d\'utilisateur et/ou le mot de passe ne sont pas corrects.')
        errorMessages.set('MEDICAL_TELETRANSMISSION_NO_SUBSCRIPTION', 'Vous n\'avez pas d\'abonnement actif de télétransmission.');
        errorMessages.set('MEDICAL_TELETRANSMISSION_NO_ADELI_NUMBER', 'Aucun numéro ADELI configuré pour ce compte');
    }
}
